var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePerfilNull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_804_2031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 250C0 111.929 111.929 0 250 0V0C388.071 0 500 111.929 500 250V250C500 388.071 388.071 500 250 500V500C111.929 500 0 388.071 0 250V250Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.835 305.96C339.422 291.337 352.989 271.284 359.648 248.591C366.307 225.899 365.727 201.695 357.99 179.347C350.252 156.999 335.742 137.618 316.476 123.901C297.211 110.184 274.15 102.813 250.5 102.812C226.85 102.812 203.789 110.184 184.524 123.901C165.259 137.618 150.748 156.999 143.01 179.347C135.273 201.695 134.693 225.899 141.352 248.591C148.011 271.284 161.578 291.337 180.165 305.96C148.316 318.72 120.527 339.883 99.7603 367.194C78.9934 394.505 66.0271 426.939 62.2437 461.04C61.9699 463.529 62.1891 466.048 62.8888 468.453C63.5885 470.858 64.7551 473.102 66.3219 475.056C69.4862 479.002 74.0886 481.53 79.1167 482.083C84.1447 482.636 89.1866 481.169 93.133 478.005C97.0795 474.841 99.6073 470.238 100.16 465.21C104.323 428.151 121.994 393.924 149.797 369.069C177.6 344.214 213.586 330.474 250.879 330.474C288.172 330.474 324.158 344.214 351.961 369.069C379.764 393.924 397.435 428.151 401.598 465.21C402.113 469.869 404.336 474.171 407.837 477.287C411.338 480.403 415.869 482.112 420.556 482.083H422.642C427.611 481.512 432.154 478.999 435.279 475.092C438.404 471.186 439.858 466.203 439.325 461.229C435.524 427.032 422.488 394.515 401.614 367.162C380.74 339.809 352.816 318.653 320.835 305.96V305.96ZM250.5 292.5C235.502 292.5 220.84 288.052 208.369 279.72C195.899 271.387 186.179 259.544 180.439 245.687C174.699 231.83 173.198 216.583 176.124 201.872C179.05 187.162 186.272 173.65 196.878 163.044C207.483 152.439 220.995 145.217 235.706 142.29C250.416 139.364 265.663 140.866 279.52 146.606C293.377 152.345 305.22 162.065 313.553 174.536C321.886 187.007 326.333 201.668 326.333 216.667C326.333 236.779 318.344 256.067 304.122 270.289C289.901 284.51 270.612 292.5 250.5 292.5Z",
    fill: "url(#paint0_linear_804_2031)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_804_2031",
    x1: 250.781,
    y1: 102.812,
    x2: 250.781,
    y2: 482.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1428A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070F3A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_804_2031"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 250C0 111.929 111.929 0 250 0V0C388.071 0 500 111.929 500 250V250C500 388.071 388.071 500 250 500V500C111.929 500 0 388.071 0 250V250Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePerfilNull);
export default __webpack_public_path__ + "static/media/imagePerfilNull.9978d8a27899a051f89d8480a6805516.svg";
export { ForwardRef as ReactComponent };